function noop(..._args: any[]): void {}

export default noop;
